import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-option-icon',
  templateUrl: './code-option.component.html'
})
export class CodeOptionComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
